import { PageHeader, QueryState, AssistantConnections } from '@/components';
import { useQuery, useMutation } from '@/lib/useQuery';
import { useAuth } from '@rbac/useCan';

/**
 * Connected AI assistants (ADR 0003, D48). Every staff member sees and ends their
 * own; with core:manage_tokens they also see every other staff member's and every
 * shopper's connection to this store. The server decides what comes back.
 */
export default function Assistants() {
  const me = useAuth();
  const q = useQuery('assistantConnections', { all: true }, { select: (r) => r.data });
  const end = useMutation('assistantDisconnect');
  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const disconnect = async (row) => {
    await end.run({ kind: row.kind, id: row.id });
    q.reload();
  };

  return (
    <div className="space-y-4">
      <PageHeader title="AI assistants" subtitle="Work on this store from Claude, ChatGPT or another assistant, as yourself." />
      <QueryState query={q}>
        {(d) => {
          const mine = d.staff.filter((c) => me && String(c.person.id) === String(me.id));
          const others = d.staff.filter((c) => !me || String(c.person.id) !== String(me.id));
          return (
            <>
              <AssistantConnections
                title="Your assistants"
                connectUrls={[{ label: 'Store management', url: `${origin}/api/mcp/store` }]}
                rows={mine}
                onDisconnect={disconnect}
                emptyText="You have not connected an assistant yet."
              />
              {d.manage ? (
                <>
                  <AssistantConnections title="Staff assistants" rows={others} showPerson onDisconnect={disconnect} emptyText="No other staff member has connected an assistant." />
                  <AssistantConnections
                    title="Shoppers' assistants"
                    connectUrls={[{ label: 'Shopping', url: `${origin}/api/mcp/shop` }]}
                    rows={d.shoppers}
                    showPerson
                    onDisconnect={disconnect}
                    emptyText="No shopper has connected an assistant. Share the address above so shoppers can shop with theirs."
                  />
                </>
              ) : null}
            </>
          );
        }}
      </QueryState>
    </div>
  );
}
